/** لوجو zalyas الملوّن حسب الهوية البصرية — يُكتب دائماً من اليسار لليمين */
const LETTERS = [
  { char: 'z', className: 'text-z-red' },
  { char: 'a', className: 'text-z-navy' },
  { char: 'l', className: 'text-z-navy' },
  { char: 'y', className: 'text-z-orange' },
  { char: 'a', className: 'text-z-green' },
  { char: 's', className: 'text-z-green' },
];

export default function Logo({ className = '' }) {
  return (
    // inline-flex لا flex: الوسم يحمل dir="ltr"، ولو كان عنصراً بعرض كامل
    // لأصبحت محاذاته الداخلية بالإنجليزية فينزاح لليسار داخل صفحة عربية.
    // بهذا الشكل يأخذ عرض محتواه ويتبع محاذاة الحاوية الأب.
    <span className={`font-serif font-bold tracking-wider inline-flex items-center ${className}`} dir="ltr">
      {LETTERS.map((letter, i) => (
        <span key={i} className={letter.className}>
          {letter.char}
        </span>
      ))}
    </span>
  );
}
